<template>
    <div class="full-width" :style="pageStyle" v-loading="loading">
        <HomeHeader
            :returnLabel="i18n.tkey('lang_return')"
            :useChatBtn="true"
            @clickBackBtn="clickReturnFunc"
            v-show="showReturnBtn !== false && viewPart == 'list'"
        />
<!--
        <div class="title-operation-part">
            <div>
                <span class="page-title-span" v-show="viewPart === 'order'" tkey="銷售單">{{i18n.tkey("lang_my_order")}}</span>
                <el-button size="large" @click="clickReturn" v-show="viewPart == 'orderInfo'" tkey="返回">{{i18n.tkey("lang_return")}}</el-button>
            </div>


        </div>-->
      <div class="editor-title-toolbar">
        <ReturnButton v-show="viewPart === 'orderInfo'"
            class="return-btn"
            @click="clickReturn"
            :label="i18n.tkey('lang_return')"
        />

        <div>
          <h2  tkey="銷售單">{{i18n.tkey("lang_my_order")}}</h2>
        </div>
      </div>

        <div v-show="viewPart == 'order'||viewPart === 'orderInfo'">

            <hallOrder
                :viewPart="viewPart"
                :fromdata="'myHallOrder'"
                @clickChangeViewPart="changeView" />

<!--            <div>
                <el-empty :description="i18n.tkey('lang_temporary_no_data')" v-if="list.length == 0">

                </el-empty>
            </div>-->
        </div>


    </div>
</template>

<script setup>
    import {inject, onBeforeMount, provide, ref, toRef, getCurrentInstance} from "vue";
    import {useUserinfo} from "@/stores/userinfo";
    import eshopopeeApi from "@/request/eshopopeeApi";
    import myUtil from "@/util/util";
    import quotationPrinter from "@/components/shopopee/print/quotationPrinter"
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import {faDownload} from '@fortawesome/free-solid-svg-icons'
    import HomeHeader from "@/components/shopopee/pageHeader/homeHeader.vue";
    import HallOrder from "@/components/shopopee/hall/hallOrder.vue";
    import ReturnButton from "@/components/shopopee/common/returnButton.vue";

    library.add(faDownload)

    const props = defineProps(["fullScreen", "showReturnBtn"])

    const userInfoRef = toRef(useUserinfo())
    const i18n = inject("i18n")
    const loading = ref(false)
    const pageStyle = ref(null)
    const { proxy } = getCurrentInstance()

    const { goDisplayIndexView } = inject('phoneView', { goDisplayIndexView: () => { proxy.$router.push({name: "home"} )} })

    const list = ref([])

    const viewPart = ref("order")
    const printCompanyCode = ref(null)
    const printRef = ref(null)

    const printerDom = ref(null)

    function getQuotationList(){
        const request = eshopopeeApi.getAllQuotationList
        const params = request.getParams()

        params.login = userInfoRef.value.login

        request.send(params, (res) => {
            list.value = res.list
        })

    }
    function changeView(mviewPart){
      viewPart.value = mviewPart
    }
    function clickReturn(){
      changeView("order")
    }
    function clickReturnFunc(){
        goDisplayIndexView()
    }

    function goListPart(){
        viewPart.value = "order"
        printCompanyCode.value = null
        printRef.value = null
    }

    function goPrintRecord(ref, companycode){
        printRef.value = ref
        printCompanyCode.value = companycode
        viewPart.value = "print"
    }

    function clickDownloadBtn(){
        printerDom.value.downloadImg()
    }

    onBeforeMount(() => {
        if (props.fullScreen === false){
            pageStyle.value = {}
        }else{
            pageStyle.value = {
                width: `${window.innerWidth}px`,
                height: `${window.innerHeight}px`
            }
        }

        if (myUtil.isNotEmpty(userInfoRef.value.login)){
            //getQuotationList()
        }
    })
</script>

<style scoped>
    .full-width {
        width: 100%;
        height: 100%;
        padding: 0px 8px;
        box-sizing: border-box;
        overflow-x: hidden;
        overflow-y: auto;
        text-align: left;
    }

    .editor-title-toolbar {
      text-align: center;
      position: relative;
      margin-bottom: 32px;
    }

    .editor-title-toolbar .return-btn {
      position: absolute;
      left: 10px;
      top: 5px;
    }

    .editor-title-toolbar .right-operation-btn {
      position: absolute;
      right: 0;
      top: 0;
    }
</style>